(function () {
  function initLeadPopup(overlay) {
    if (overlay.dataset.lpInitialized === 'true') return;
    overlay.dataset.lpInitialized = 'true';

    var storageKey = 'lead-popup-shown:' + overlay.dataset.formSlug;
    var delay = parseInt(overlay.dataset.delay, 10) || 35000;
    var form = overlay.querySelector('[data-lead-popup-form]');
    var statusEl = overlay.querySelector('[data-lead-popup-status]');
    var successEl = overlay.querySelector('[data-lead-popup-success]');
    var submitButton = overlay.querySelector('.lead-popup-submit');

    function openPopup() {
      if (sessionStorage.getItem(storageKey)) return;
      overlay.hidden = false;
      sessionStorage.setItem(storageKey, 'true');
    }

    function closePopup() {
      overlay.hidden = true;
    }

    overlay.querySelectorAll('[data-lead-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closePopup();
    });

    function showStatus(message, variant) {
      if (!message) {
        statusEl.hidden = true;
        statusEl.textContent = '';
        statusEl.className = 'lead-popup-status';
        return;
      }
      statusEl.hidden = false;
      statusEl.textContent = message;
      statusEl.className = 'lead-popup-status lead-popup-status--' + variant;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        showStatus('Please fill in all required fields.', 'error');
        return;
      }

      var formData = new FormData(form);
      submitButton.disabled = true;
      showStatus('Sending...', 'success');

      fetch('/apps/buytime/lead-form', {
        method: 'POST',
        body: formData,
      })
        .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
        .then(function (result) {
          if (result.ok && result.data && result.data.ok) {
            showStatus('', null);
            form.hidden = true;
            successEl.hidden = false;
          } else {
            showStatus((result.data && result.data.message) || 'Something went wrong. Please try again.', 'error');
          }
        })
        .catch(function () {
          showStatus('Something went wrong. Please try again.', 'error');
        })
        .finally(function () {
          submitButton.disabled = false;
        });
    });

    setTimeout(openPopup, delay);
  }

  document.querySelectorAll('[data-lead-popup]').forEach(initLeadPopup);
})();
